<template>
  <CDropdown
    inNav
    class="c-header-nav-items"
    placement="bottom-end"
    add-menu-classes="pt-0 pb-0"
  >
    <template #toggler>
      <CHeaderNavLink>
        <div class="c-avatar">
          <img :src="profileUrl" class="c-avatar-img " />
        </div>
      </CHeaderNavLink>
    </template>
    <CDropdownHeader>
      {{ name }}
    </CDropdownHeader>
    <CDropdownItem @click="logout()">
      <CIcon name="cil-lock-locked" /> Logout
    </CDropdownItem>
  </CDropdown>
</template>

<script>
import { getProfile } from '@/utils/profile'

export default {
  name: 'TheHeaderDropdownAccnt',
  data() {
    return {
      name: '',
      profileUrl: '/img/avatars/6jpg'
    }
  },
  created() {
    if (getProfile()) {
      this.name = getProfile().first_name
      this.profileUrl = getProfile().profile_url
    }
  },
  methods: {
    logout() {
      this.$store
        .dispatch('logout')
        .then(() => {})
        .catch(() => {})
    }
  }
}
</script>

<style scoped>
.c-icon {
  margin-right: 0.3rem;
}
</style>
